/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { L as Loader, d as defineCustomElement$1 } from './loader.js';

const CalciteLoader = Loader;
const defineCustomElement = defineCustomElement$1;

export { CalciteLoader, defineCustomElement };
